import { History, createBrowserHistory } from 'history';

export class HistoryStore {
  history: History = createBrowserHistory();
}
